import React from 'react';
import { DesktopOrTabletContainer, MobileContainer } from '../../../../responsiveTools/ResponsiveContainers';
import DesktopFooter from './DesktopFooter/DesktopFooter';

export default function Footer () {
    return (
        <>
            <DesktopOrTabletContainer>
                <DesktopFooter />
            </DesktopOrTabletContainer>
            <MobileContainer>
            </MobileContainer>
        </>
    )
};